import React from "react";
import BackToHomeHeader from "../components/common/BackToHomeHeader";
import { PlaymemoriesIntroSection } from "../components/pages/playmemories/PlaymemoriesPageSection";

import { NextProjectFooter } from "../components/common/Footer";

const PlaymemoriesPage = () => {
	return [
		<BackToHomeHeader key="header" title="Playmemories" company="Sony" />,
		<PlaymemoriesIntroSection key="introSection" />,
		<NextProjectFooter key="homeFooter" href="/grow" />,
	];
};

export default PlaymemoriesPage;



// WEBPACK FOOTER //
// ./src/pages/playmemories.js